import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { MessageService } from 'primeng/api';
import { VMSConstants } from '../../../shared/constants/vms-constants';
import { DataService } from '../../../shared/services';
import { IForgotPassword, ILoginDetails } from '../../models';
import { UserService } from '../../services/user.service';

@Component({
  selector: 'app-forget-password',
  templateUrl: './forget-password.component.html',
  styleUrls: ['./forget-password.component.css'],
  providers: [MessageService],
  encapsulation: ViewEncapsulation.None

})
export class ForgetPasswordComponent implements OnInit {
  forgotPasswordForm: FormGroup;
  url:string ="../../../assets/img/forgot-password.svg";
  urlOne:string ="assets/img/logo-dev.png";
  userName:string;
  errorMessage: any;
  dataServiceSharedData: any;
  saveModal: boolean = false;
  constructor(
    private _formBuilder: FormBuilder,
    private _userService: UserService,
    private _route: ActivatedRoute,
    private _router: Router,
    private messageService: MessageService,
    private dataService: DataService,
    private spinner: NgxSpinnerService,
  ) { }

  ngOnInit(): void {
    this.dataService.getSharedData().subscribe(data => this.dataServiceSharedData = data);
    this.userName = this.dataServiceSharedData.userName;
    //console.log(this.userName);
    this.dataService.setSharedData(null);
    this.forgotPasswordForm = this._formBuilder.group({
      email: ['', [Validators.required, Validators.pattern(VMSConstants.emailValidator)]]
    });
  }

  public errorHandling = (control: string, error: string) => {
    return this.forgotPasswordForm.controls[control].hasError(error);
  }
  get forgotPasswordFormControl() {
    return this.forgotPasswordForm.controls;
  }
  generateForgotPasswordEmail({ value }: { value: IForgotPassword }): void {
    this.messageService.add({ severity: 'success', summary: 'Confirmed', detail: 'Your Password reset email has been sent!' });
    this._userService.forgotPassword(value).subscribe((data: any) => {
      this.saveModal = true;
    }, error => {
      console.log(error)
    });
  }
  onCancel()
  {
    this._router.navigate(['/login']);
  }
  saveRedirect() {
    setTimeout(() => {
      this.spinner.show();
      setTimeout(() => {
        this.spinner.hide();
      }, 2000);
      this._router.navigate(['/login']);
    }, 1000);
  }
}
